import isString from 'lodash/isString';

import React from 'react';

import AntdEmpty from 'antd/lib/empty';
import AntdButton from 'antd/lib/button';

import Admin from 'hive-admin';

const RenderInputWrapper = React.forwardRef(
  ({ addNewItemAction, children, ...props }, ref) => (
    <>
      {addNewItemAction}
      {React.cloneElement(children, { ref, ...props })}
    </>
  ),
);

export default ({
  name,
  label,
  url,
  fields,
  placeholder,
  searchPaths = ['name'],
  mode,
  ...config
} = {}) => ['FieldConnectionSelect', {
  name,
  label,
  url,
  placeholder,
  mode: mode || 'default',
  searchPaths,
  // eslint-disable-next-line no-unused-vars
  prepareValueForForm: (value, props) => {
    if (Array.isArray(value)) {
      if (value && value.length) {
        value = value.filter(item => typeof item === 'string');
      }
    } else if (typeof value !== 'string') {
      value = null;
    }
    return value;
  },
  renderChoices: (field, props) => ([
    ...props.choices.map(
      choice => props.renderChoice(choice, field, props)
    ),
    (
      <props.choiceClass
        key="_CREATE_NEW_"
        value={null}
        onClick={({ domEvent }) => {
          try {
            domEvent.preventDefault();
            domEvent.stopPropagation();
            field.addNewButtonActionRef.current.toggleModalOpen(
              true,
            );
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log('error on ConnectionSelectWithCreate click:', error);
          }
        }}
      >
        <div
          style={{
            opacity: 0.5,
            position: 'relative',
            paddingTop: '6px',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: -5,
              left: '-100vw',
              right: '-100vw',
              borderTop: '1px solid #aaa',
            }}
          />
          + Dodaj
        </div>
      </props.choiceClass>
    ),
  ]),
  renderInput: (inputProps, extras, props, input) => {
    if (!input?.addNewButtonActionRef) {
      input.addNewButtonActionRef = React.createRef();
    }
    if (!input?.addNewButtonActionSearchValueRef) {
      input.addNewButtonActionSearchValueRef = React.createRef('');
    }
    if (typeof input.state?.search === 'string') {
      const search = input.state.search.trim();
      if (search.length) {
        input.addNewButtonActionSearchValueRef.current = search;
      }
    }
    return (
      <RenderInputWrapper
        addNewItemAction={(
          props.addNewItemAction.render({
            modalProps: {
              centered: true,
              closable: true,
              destroyOnClose: true,
            },
            form: props.form,
            client: props.client,
            storage: props.storage,
            viewer: props.viewer,
            activity: 'create',
            actionSelectMode: props.mode,
            onCreateNew: props.onCreateNew,
            addNewButtonActionRef: (
              input.addNewButtonActionRef
            ),
            addNewButtonActionSearchValueRef: (
              input.addNewButtonActionSearchValueRef
            ),
            data: {
              name: input.addNewButtonActionSearchValueRef?.current,
            },
          })
        )}
      >
        {
          React.cloneElement(
            input.renderInput(inputProps, extras, props, input),
            {
              notFoundContent: (
                <AntdEmpty>
                  <AntdButton
                    type="primary"
                    icon="plus"
                    style={{ marginBottom: '15px' }}
                    onClick={() => {
                      input.addNewButtonActionRef.current
                        .toggleModalOpen(
                          true,
                        );
                    }}
                  >
                    + Dodaj
                  </AntdButton>
                </AntdEmpty>
              ),
            },
          )
        }
      </RenderInputWrapper>
    );
  },
  addNewItemAction: Admin.compileFromLibrary(['ActionWithFormModal', {
    title: `Dodaj - ${label}`,
    fields: [
      ...fields,
    ],
    renderAction: (props, action) => {
      if (props.addNewButtonActionRef) {
        props.addNewButtonActionRef.current = action;
      }
      return action.renderAction({
        ...props,
        style: { display: 'none' },
      });
    },
    actions: [
      ['ActionWithFormBasedRequest', {
        name: `create-item-${name}`,
        title: 'Napravi',
        messageWorking: 'Pravim...',
        messageSuccess: 'Napravljeno!',
        disabled: [
          ['condition.isLoading'],
          ['condition.and', [
            ['not', ['condition.anyFieldTouched']],
            ({ searchParams, data }) => !searchParams?.duplicate || !data,
          ]],
          ['condition.anyFieldHasError'],
        ],
        handleSuccess: (data, props) => {
          if (props.onCreateNew) {
            props.onCreateNew(data, props);
          } else {
            let value = data._id;
            if (['multiple', 'tags'].includes(mode)) {
              const previousValue = (
                props.parentForm?.getFieldValue(name)
                || []
              ).filter(item => isString(item));
              value = [...previousValue, data._id];
            }
            props.parentForm?.setFields?.({
              [name]: {
                value,
                touched: true,
              },
            });
          }
          props.modalAction?.toggleModalOpen?.(false);
        },
        getRequestConfig: (props, data) => ({
          url,
          method: 'POST',
          data,
        }),
      }],
    ],
  }]),
  ...config,
}];
